import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

// Redux
import { getProfile } from '../../../redux-store/auth';
import { getCurrentLicense } from '../../../redux-store/license';

// Hooks
import useServerSentEvents from "../../hooks/useServerSentEvents";

// Components
import GenericModal, { ClosedModal } from "../genericModal";
import OButton from "../../styled/button";

// Locales
import I18n from "../../../i18n";

const ServerSentEvents = () => {

    const dispatch = useDispatch();

    const userSession = useSelector((state: any) => state.auth.userSession);

    const [modal, setModal] = useState(ClosedModal);

    const reasonBuilder = (type: any) => {
        switch (type) {
            case 'updatedPlan':
                return I18n.t(`refreshSession.reasons.${type}`);
            default:
                break;
        }
    }

    const refreshSession = () => {
        dispatch(getProfile());
        dispatch(getCurrentLicense());
    }

    const handleEvents = (data: { type: any; }) => {

        const type = data.type;

        const reason = reasonBuilder(type);

        switch (type) {
            case "updatedPlan":
                refreshSession();

                setModal({
                    open: true,
                    title: I18n.t('refreshSession.title'),
                    renderBody: () => <p className="paragraph regular">{I18n.t('refreshSession.reasons.title') + reason}</p>,
                    renderActions: () => (
                        <OButton $terceary onClick={() => setModal(ClosedModal)}>
                            {I18n.t('buttons.actions.understood')}
                        </OButton>
                    ),
                    size: 'small',
                    onClose: () => setModal(ClosedModal)
                });

                break;

            default:
                break;
        }
    };

    useServerSentEvents(userSession._id, handleEvents);

    return <GenericModal
        open={modal.open}
        title={modal.title}
        renderBody={modal.renderBody}
        renderActions={modal.renderActions}
        onClose={modal.onClose}
    />;
}

export default ServerSentEvents;